// Route → import map for dynamic preloading
const ROUTE_IMPORTS: Record<string, () => Promise<unknown>> = {
  '/dashboard': () => import('@/pages/Dashboard'),
  '/transacoes': () => import('@/pages/Transactions'),
  '/lancamentos': () => import('@/pages/ReleasesV2'),
  '/cartoes': () => import('@/pages/Cards'),
  '/contas': () => import('@/pages/Accounts'),
  '/categorias': () => import('@/pages/Categories'),
  '/orcamentos': () => import('@/pages/Budgets'),
  '/metas': () => import('@/pages/Goals'),
  '/relatorios': () => import('@/pages/Reports'),
  '/configuracoes': () => import('@/pages/Settings'),
  '/ajuda-e-suporte': () => import('@/pages/HelpSupport'),
  '/documentacao': () => import('@/pages/Documentation'),
  '/agenda': () => import('@/pages/Agenda'),
  '/admin': () => import('@/pages/Admin'),
};

// Preload a route's component via dynamic import
export const preloadRoute = (routePath: string) => {
  const importFn = ROUTE_IMPORTS[routePath];
  if (importFn) {
    importFn().catch(() => {
      // Silently fail - the route will load on navigation
    });
  }
};

// Inject <link rel="modulepreload"> for critical chunks
const modulePreloadedPaths = new Set<string>();

export const modulePreload = (routePath: string) => {
  if (modulePreloadedPaths.has(routePath)) return;
  modulePreloadedPaths.add(routePath);
  
  // Trigger import to get the resolved module URL for browser-level prefetching
  const importFn = ROUTE_IMPORTS[routePath];
  if (importFn) {
    importFn().catch(() => {});
  }
};

// Preload routes based on user behavior patterns
export const setupIntelligentPreloading = () => {
  const setupHoverListeners = () => {
    const navLinks = document.querySelectorAll('a[href^="/"]');
    navLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (href) {
        link.addEventListener('mouseenter', () => preloadRoute(href), { once: true, passive: true });
        link.addEventListener('focus', () => preloadRoute(href), { once: true, passive: true });
        link.addEventListener('touchstart', () => preloadRoute(href), { once: true, passive: true });
      }
    });
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(setupHoverListeners, { timeout: 500 });
  } else {
    setTimeout(setupHoverListeners, 50);
  }
  
  // Preload dashboard immediately if not already there
  if (window.location.pathname !== '/dashboard' && window.location.pathname !== '/') {
    preloadRoute('/dashboard');
  }
};

// Initialize preloading when DOM is ready
export const initializeRoutePreloading = () => {
  if (document.readyState === 'complete') {
    setupIntelligentPreloading();
  } else {
    window.addEventListener('load', setupIntelligentPreloading, { once: true });
  }
};
